import Quill from 'quill'

const Embed = Quill.import('blots/embed')

class MentionBlot extends Embed {
	static create(value) {
		const node = super.create()
		MentionBlot.buildSpan(value, node)
		return node
	}

	static value(node) {
		const { user: id, fullname, me } = node.dataset
		return { id, fullname, me }
	}

	// Quill's Embed.update only reacts to characterData mutations on its guard
	// nodes. A word-delete (⌥⌫) removes the contenteditable content node
	// outright — a childList mutation — so the blot survives with its dataset
	// intact, invisible but still serialising to <@id> on send. Drop the blot
	// when its content has been destroyed.
	update(mutations, context) {
		super.update(mutations, context)
		const lostContent = mutations.some(
			(mutation) =>
				mutation.type === 'childList' &&
				Array.from(mutation.removedNodes).includes(this.contentNode)
		)
		if (lostContent) this.remove()
	}

	static buildSpan({ id, fullname, me }, node) {
		if (me === 'true') {
			node.classList.add('mention-me')
		}
		const span1 = document.createElement('span')
		span1.className = 'mention-at'
		span1.innerText = '@'
		node.appendChild(span1)
		const span2 = document.createElement('span')
		span2.className = 'mention-name'
		span2.innerText = fullname
		Object.assign(node.dataset, {
			user: id,
			fullname,
			me,
		})
		node.appendChild(span2)
	}
}

MentionBlot.blotName = 'mention'
MentionBlot.tagName = 'span'
MentionBlot.className = 'quill-mention'

export default MentionBlot
